// 字幕与剧集模拟数据
// 说明：
// - 本文件在原有“原/翻译字幕”mock 基础上，新增“剧集列表（1-30集）”及统一接口
// - 每集包含：seriesId、episodeId、集数标题、扁平化视频地址字段（originalVideoUrl/fullUrl/noBgmUrl/noSubtitleUrl/dubbingUrl），以及对应字幕
// - 目前全部集使用同一视频地址与同一份字幕数据，便于前端联调

// 原字幕数据
const originalSubtitleData = [
  {"startTime":"00:00:01,320","startSeconds":1.32,"endTime":"00:00:02,660","endSeconds":2.66,"text":"林先生阿斯利康丢进来撒大口径卢萨卡登记"},
  {"startTime":"00:00:02,660","startSeconds":2.66,"endTime":"00:00:03,859","endSeconds":3.859,"text":"您的花"},
  {"startTime":"00:00:04,139","startSeconds":4.139,"endTime":"00:00:05,059","endSeconds":5.059,"text":"按您的要求"},
  {"startTime":"00:00:05,059","startSeconds":5.059,"endTime":"00:00:06,160","endSeconds":6.16,"text":"没有去除玫瑰刺"},
  {"startTime":"00:00:12,400","startSeconds":12.4,"endTime":"00:00:13,300","endSeconds":13.3,"text":"辛苦了"},
  {"startTime":"00:00:16,559","startSeconds":16.559,"endTime":"00:00:17,559","endSeconds":17.559,"text":"这是你的小费"},
  {"startTime":"00:00:23,820","startSeconds":23.82,"endTime":"00:00:24,800","endSeconds":24.8,"text":"不好意思啊"},
  {"startTime":"00:00:25,960","startSeconds":25.96,"endTime":"00:00:26,859","endSeconds":26.859,"text":"啊"},
  {"startTime":"00:00:27,660","startSeconds":27.66,"endTime":"00:00:29,620","endSeconds":29.62,"text":"没事没事"},
  {"startTime":"00:00:31,019","startSeconds":31.019,"endTime":"00:00:31,920","endSeconds":31.92,"text":"这200块"},
  {"startTime":"00:00:31,920","startSeconds":31.92,"endTime":"00:00:33,759","endSeconds":33.759,"text":"又能让如霜轻松点了"},
  {"startTime":"00:00:34,320","startSeconds":34.32,"endTime":"00:00:35,119","endSeconds":35.119,"text":"子程"},
  {"startTime":"00:00:36,359","startSeconds":36.359,"endTime":"00:00:37,140","endSeconds":37.14,"text":"那个花"},
  {"startTime":"00:00:37,140","startSeconds":37.14,"endTime":"00:00:38,359","endSeconds":38.359,"text":"是专门给我买的吗"},
  {"startTime":"00:00:38,719","startSeconds":38.719,"endTime":"00:00:39,520","endSeconds":39.52,"text":"当然"},
  {"startTime":"00:00:39,600","startSeconds":39.6,"endTime":"00:00:41,119","endSeconds":41.119,"text":"送给我一生的挚爱"},
  {"startTime":"00:00:41,320","startSeconds":41.32,"endTime":"00:00:42,719","endSeconds":42.719,"text":"沈如霜小姐"},
  {"startTime":"00:00:44,640","startSeconds":44.64,"endTime":"00:00:45,439","endSeconds":45.439,"text":"香吗"},
  {"startTime":"00:00:46,200","startSeconds":46.2,"endTime":"00:00:47,000","endSeconds":47,"text":"香"},
  {"startTime":"00:00:47,600","startSeconds":47.6,"endTime":"00:00:48,399","endSeconds":48.399,"text":"你比它香"},
  {"startTime":"00:00:55,679","startSeconds":55.679,"endTime":"00:00:56,899","endSeconds":56.899,"text":"如霜"},
  {"startTime":"00:01:17,159","startSeconds":77.159,"endTime":"00:01:18,739","endSeconds":78.739,"text":"感谢888包厢"},
  {"startTime":"00:01:18,739","startSeconds":78.739,"endTime":"00:01:20,819","endSeconds":80.819,"text":"至尊VIP沈如霜小姐"},
  {"startTime":"00:01:20,819","startSeconds":80.819,"endTime":"00:01:24,219","endSeconds":84.219,"text":"豪赠488888元"},
  {"startTime":"00:01:24,219","startSeconds":84.219,"endTime":"00:01:26,019","endSeconds":86.019,"text":"请全场喝酒"},
  {"startTime":"00:01:26,019","startSeconds":86.019,"endTime":"00:01:28,359","endSeconds":88.359,"text":"每桌一瓶黑桃A"},
  {"startTime":"00:01:53,819","startSeconds":113.819,"endTime":"00:01:54,680","endSeconds":114.68,"text":"霜姐"},
  {"startTime":"00:01:55,000","startSeconds":115,"endTime":"00:01:56,819","endSeconds":116.819,"text":"这次破产还款的合同"},
  {"startTime":"00:01:56,819","startSeconds":116.819,"endTime":"00:01:58,120","endSeconds":118.12,"text":"金额填多少呀"},
  {"startTime":"00:02:00,319","startSeconds":120.319,"endTime":"00:02:01,260","endSeconds":121.26,"text":"500万"},
  {"startTime":"00:02:03,879","startSeconds":123.879,"endTime":"00:02:04,859","endSeconds":124.859,"text":"这是我对周璟"},
  {"startTime":"00:02:04,859","startSeconds":124.859,"endTime":"00:02:06,019","endSeconds":126.019,"text":"最后一次考验"},
  {"startTime":"00:02:06,319","startSeconds":126.319,"endTime":"00:02:07,060","endSeconds":127.06,"text":"我可不能让他"},
  {"startTime":"00:02:07,060","startSeconds":127.06,"endTime":"00:02:08,419","endSeconds":128.419,"text":"一口气就还完了"},
  {"startTime":"00:02:08,819","startSeconds":128.819,"endTime":"00:02:09,460","endSeconds":129.46,"text":"考验"}
]

// 翻译字幕数据（基于原字幕生成的英文翻译）
const translatedSubtitleData = [
  {"startTime":"00:00:01,320","startSeconds":1.32,"endTime":"00:00:02,660","endSeconds":2.66,"text":"Mr. Lin AstraZeneca threw in large-caliber Lusaka registration","speed":"1.0x"},
  {"startTime":"00:00:02,660","startSeconds":2.66,"endTime":"00:00:03,859","endSeconds":3.859,"text":"Your flowers","speed":"0.9x"},
  {"startTime":"00:00:04,139","startSeconds":4.139,"endTime":"00:00:05,059","endSeconds":5.059,"text":"As per your request","speed":"1.1x"},
  {"startTime":"00:00:05,059","startSeconds":5.059,"endTime":"00:00:06,160","endSeconds":6.16,"text":"The rose thorns were not removed","speed":"1.0x"},
  {"startTime":"00:00:12,400","startSeconds":12.4,"endTime":"00:00:13,300","endSeconds":13.3,"text":"Thank you for your hard work","speed":"0.8x"},
  {"startTime":"00:00:16,559","startSeconds":16.559,"endTime":"00:00:17,559","endSeconds":17.559,"text":"This is your tip","speed":"1.0x"},
  {"startTime":"00:00:23,820","startSeconds":23.82,"endTime":"00:00:24,800","endSeconds":24.8,"text":"Sorry about that","speed":"0.9x"},
  {"startTime":"00:00:25,960","startSeconds":25.96,"endTime":"00:00:26,859","endSeconds":26.859,"text":"Ah","speed":"1.2x"},
  {"startTime":"00:00:27,660","startSeconds":27.66,"endTime":"00:00:29,620","endSeconds":29.62,"text":"It's okay, it's okay","speed":"1.0x"},
  {"startTime":"00:00:31,019","startSeconds":31.019,"endTime":"00:00:31,920","endSeconds":31.92,"text":"This 200 yuan","speed":"1.1x"},
  {"startTime":"00:00:31,920","startSeconds":31.92,"endTime":"00:00:33,759","endSeconds":33.759,"text":"Will make Rushuang feel more relaxed","speed":"0.9x"},
  {"startTime":"00:00:34,320","startSeconds":34.32,"endTime":"00:00:35,119","endSeconds":35.119,"text":"Zicheng","speed":"1.0x"},
  {"startTime":"00:00:36,359","startSeconds":36.359,"endTime":"00:00:37,140","endSeconds":37.14,"text":"That flower","speed":"1.1x"},
  {"startTime":"00:00:37,140","startSeconds":37.14,"endTime":"00:00:38,359","endSeconds":38.359,"text":"Was it bought specifically for me?","speed":"0.9x"},
  {"startTime":"00:00:38,719","startSeconds":38.719,"endTime":"00:00:39,520","endSeconds":39.52,"text":"Of course","speed":"1.0x"},
  {"startTime":"00:00:39,600","startSeconds":39.6,"endTime":"00:00:41,119","endSeconds":41.119,"text":"For my lifelong love","speed":"1.0x"},
  {"startTime":"00:00:41,320","startSeconds":41.32,"endTime":"00:00:42,719","endSeconds":42.719,"text":"Miss Shen Rushuang","speed":"0.9x"},
  {"startTime":"00:00:44,640","startSeconds":44.64,"endTime":"00:00:45,439","endSeconds":45.439,"text":"Does it smell good?","speed":"1.1x"},
  {"startTime":"00:00:46,200","startSeconds":46.2,"endTime":"00:00:47,000","endSeconds":47,"text":"It smells good","speed":"1.0x"},
  {"startTime":"00:00:47,600","startSeconds":47.6,"endTime":"00:00:48,399","endSeconds":48.399,"text":"You smell better than it","speed":"0.9x"},
  {"startTime":"00:00:55,679","startSeconds":55.679,"endTime":"00:00:56,899","endSeconds":56.899,"text":"Rushuang","speed":"1.0x"},
  {"startTime":"00:01:17,159","startSeconds":77.159,"endTime":"00:01:18,739","endSeconds":78.739,"text":"Thank you to VIP room 888","speed":"1.0x"},
  {"startTime":"00:01:18,739","startSeconds":78.739,"endTime":"00:01:20,819","endSeconds":80.819,"text":"Supreme VIP Miss Shen Rushuang","speed":"0.9x"},
  {"startTime":"00:01:20,819","startSeconds":80.819,"endTime":"00:01:24,219","endSeconds":84.219,"text":"Generously donated 488,888 yuan","speed":"1.0x"},
  {"startTime":"00:01:24,219","startSeconds":84.219,"endTime":"00:01:26,019","endSeconds":86.019,"text":"Please treat everyone to drinks","speed":"1.1x"},
  {"startTime":"00:01:26,019","startSeconds":86.019,"endTime":"00:01:28,359","endSeconds":88.359,"text":"One bottle of Ace of Spades per table","speed":"0.9x"},
  {"startTime":"00:01:53,819","startSeconds":113.819,"endTime":"00:01:54,680","endSeconds":114.68,"text":"Sister Shuang","speed":"1.0x"},
  {"startTime":"00:01:55,000","startSeconds":115,"endTime":"00:01:56,819","endSeconds":116.819,"text":"This bankruptcy repayment contract","speed":"1.0x"},
  {"startTime":"00:01:56,819","startSeconds":116.819,"endTime":"00:01:58,120","endSeconds":118.12,"text":"How much should the amount be?","speed":"0.9x"},
  {"startTime":"00:02:00,319","startSeconds":120.319,"endTime":"00:02:01,260","endSeconds":121.26,"text":"5 million","speed":"1.0x"},
  {"startTime":"00:02:03,879","startSeconds":123.879,"endTime":"00:02:04,859","endSeconds":124.859,"text":"This is my last test for Zhou Jing","speed":"1.0x"},
  {"startTime":"00:02:04,859","startSeconds":124.859,"endTime":"00:02:06,019","endSeconds":126.019,"text":"I can't let him","speed":"1.1x"},
  {"startTime":"00:02:06,319","startSeconds":126.319,"endTime":"00:02:07,060","endSeconds":127.06,"text":"Pay it off all at once","speed":"0.9x"},
  {"startTime":"00:02:07,060","startSeconds":127.06,"endTime":"00:02:08,419","endSeconds":128.419,"text":"Test","speed":"1.0x"},
  {"startTime":"00:02:08,819","startSeconds":128.819,"endTime":"00:02:09,460","endSeconds":129.46,"text":"Test","speed":"1.0x"}
]

// 默认资源（所有集复用）
const defaultVideoUrl = 'http://test-script.juhaokanya.com/demo/video/1.mp4' // 默认播放地址
const defaultDubbingUrl = 'http://test-script.juhaokanya.com/demo/video/dubbing/1.mp4' // 默认配音地址
const defaultSeriesId = 'SERIES-001' // 默认剧ID

// 生成 1-30 集的剧集列表
// 字段说明：
// - seriesId：剧ID
// - episodeId：集ID
// - episodeNumber：第几集（数字）
// - title：展示标题
// - videoUrls：按 YoutubeVideoTypeObject 分类的播放地址
// - dubbingUrl：配音视频地址
// - originalSubtitles / translatedSubtitles：对应的原/翻译字幕数组
const episodeList = Array.from({ length: 30 }).map((_, index) => {
  const episodeNumber = index + 1
  return {
    seriesId: defaultSeriesId,
    episodeNumber, // 仅保留集序号，外层可自行组装标题与下拉
    fullUrl: defaultVideoUrl,           // 完整版本
    noBgmUrl: defaultVideoUrl,          // 无BGM版本
    noSubtitleUrl: defaultVideoUrl,     // 无字幕版本
    dubbingUrl: defaultDubbingUrl,      // 配音视频地址
    originalSubtitles: originalSubtitleData,
    translatedSubtitles: translatedSubtitleData
  }
})

const defaultEpisode = episodeList[0]

// 获取原字幕数据的模拟接口
export function getOriginalSubtitles() {
  return {
    code: 0,
    data: originalSubtitleData,
    message: '获取原字幕成功'
  }
}

// 获取翻译字幕数据的模拟接口
export function getTranslatedSubtitles() {
  return {
    code: 0,
    data: translatedSubtitleData,
    message: '获取翻译字幕成功'
  }
}

// 获取剧集及字幕数据
// 返回结构：
// {
//   code: 0,
//   data: {
//     seriesId,                 // 剧ID
//     defaultEpisodeId,         // 默认选中集ID
//     episodes: Episode[],      // 1-30 集列表
//     defaultEpisode            // 默认集完整对象（便于直接使用）
//   }
// }
export function getSeriesWithSubtitles() {
  return {
    code: 0,
    data: {
      seriesId: defaultSeriesId,
      episodes: episodeList,
      defaultEpisode
    },
    message: '获取剧集及字幕成功'
  }
}

// 默认导出所有数据
export default {
  getOriginalSubtitles,
  getTranslatedSubtitles,
  getSeriesWithSubtitles
}

